<template>
  <Flex direction="row" :gap="12" align-y="center" :padding-y="12">
    <Text size="text-sm" weight="semibold">Zakres listy</Text>
    <Select
      :disabled="!canFilter"
      :items="items"
      :model-value="listFor"
      size="sm"
      style="width: 160px"
      @click="!canFilter && emit('upgrade')"
      @update:model-value="emit('listFor', $event)"
    />
    <Divider direction="vertical" />
    <Switch
      class="menu-group"
      :disabled="!canSort"
      label="Grupowanie"
      :model-value="groupBy"
      size="sm"
      @click="!canSort && emit('upgrade')"
      @update:model-value="emit('groupBy', $event)"
    />
  </Flex>
</template>

<script lang="ts" setup>
  import { Select, Switch } from '@/components/ui'
  import Divider from '@/components/ui/Divider/Divider.vue'
  import Flex from '@/components/ui/Flex/Flex.vue'
  import Text from '@/components/ui/Text/Text.vue'

  defineProps<{
    canFilter: boolean
    canSort: boolean
    count: string
    groupBy: boolean
    items: { id: string; label: string }[]
    listFor: string
  }>()
  const emit = defineEmits<{
    groupBy: [value: boolean]
    listFor: [value: number | string | null]
    upgrade: []
  }>()
</script>

<style scoped>
  .menu-group {
    margin-bottom: 10px;
  }
</style>
